export default "__VITE_ASSET__DYe$p$Z1__"